import { useQuery } from '@apollo/client';
import { CAN_USE_SOCIAL_MEDIA_INTEGRATION } from 'api/social-media-integration/queries';
import {
  CanUseSocialMediaIntegration,
  CanUseSocialMediaIntegrationVariables,
} from 'api/social-media-integration/types/CanUseSocialMediaIntegration';

export const useIsNewSocialMediaIntegration = () => {
  return useQuery<
    CanUseSocialMediaIntegration,
    CanUseSocialMediaIntegrationVariables
  >(CAN_USE_SOCIAL_MEDIA_INTEGRATION, {
    variables: {
      input: {},
    },
  });
};
